<div  fxLayout="column" fxLayoutGap="20px">
  <span  fxLayout="row" fxLayoutAlign="center center" class="alert" ngStyle.xs="font-size:20px"> {{ 'alert' | transloco}}</span>
  <span fxLayout="column" fxLayoutGap="20px" >
    <span fxFlex fxLayout="row" class="alertmsg" fxLayoutAlign="center center" ngStyle.xs="font-size:12px;padding-top:2px;padding-bottom:10px">{{ 'you_will_loose_your_current_changes' | transloco}}</span>

    <div fxLayout="column" fxLayoutAlign="center center">
      <span fxLayoutGap="10px" fxLayout="row" >
        <div fxFlex="50" fxLayoutAlign="start ">
          <button color="primary" ngStyle.xs="width:100px;font-size:15px;height:35px" mat-flat-button class="cancel-button medium" (click)="cancel()"
            >{{ 'cancel' | transloco}}</button>
        </div>
        <div fxFlex="50" fxLayoutAlign="end ">
          <button color="primary" ngStyle.xs="width:100px;font-size:15px;height:35px"  mat-stroked-button class="ok-button medium" (click)="ok()">{{ 'ok' | transloco}}</button>
        </div>
      </span>
    </div>
  </span>

</div>
